import moment from 'moment'

import { ICalendarSettings } from '../types'

const defaultUserSettings: ICalendarSettings = {
  amountOfCalendarDays: 3,
  colorContrast: 'rgba(201,201,201, 0.8)',
  colorContrastValue: '10',
  inActivePersonIds: [],
  zoomLevelValue: '30',
  calendarDate: moment().format('YYYY-MM-DD'),
}

export const getUserSettings = (): ICalendarSettings => {
  const userSettingsLocalStorage: string | null =
    localStorage.getItem('userSettings')
  if (userSettingsLocalStorage) {
    const oldUserSettings: ICalendarSettings = JSON.parse(
      userSettingsLocalStorage,
    )
    return { ...defaultUserSettings, ...oldUserSettings }
  }
  return defaultUserSettings
}

export const setUserSettings = (
  updateSettingObject: Partial<ICalendarSettings>,
): void => {
  const userSettingsLocalStorage: string | null =
    localStorage.getItem('userSettings')
  if (userSettingsLocalStorage) {
    const oldUserSettings: ICalendarSettings = JSON.parse(
      userSettingsLocalStorage,
    )
    const newUserSettings: ICalendarSettings = {
      ...defaultUserSettings,
      ...oldUserSettings,
      ...updateSettingObject,
    }
    localStorage.setItem('userSettings', JSON.stringify(newUserSettings))
    return
  }
  const tweakDefaultSettings: ICalendarSettings = {
    ...defaultUserSettings,
    ...updateSettingObject,
  }
  localStorage.setItem('userSettings', JSON.stringify(tweakDefaultSettings))
}
